// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.padded[data-v-1abcd5ca] {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n", ""]);
// Exports
module.exports = exports;
